if (window['jQuery']) {
    (function ($) {
        if (window['TCTServer'] && window['TCTServer']['admin']) return;
        TCT.debug('After TCTServer admin');
        if (!window['TCT'] || !window['TCT']['hasTracking']) return;
        TCT.debug('After hasTracking');
        if (!window['TCT'] || !window['TCT']['Testing']) return;
        TCT.debug('After Testing');
        if (!window['branch'] || !window['branch']['banner']) return;
        TCT.debug('After branch banner');
        var testData = false;
        var TRACKING_PREFIX = 'download_app_banner_';

        if (shouldShowBanner()) {
            if (shouldRunTest()) {
                TCT.Testing.getTestData(970, null).then(function (data) {
                    TCT.debug('Test data:', data);

                    testData = data;

                    scheduleBanner();

                }, scheduleBanner);
            } else {
                scheduleBanner();
            }
        }

        function isAndroid() {
            var body = document.querySelector("body");
            var ua = navigator.userAgent.toLowerCase();
            return ua.indexOf("android") > -1;  //&& ua.indexOf("mobile");
        }

        function isIOS() {
            var body = document.querySelector("body");
            var ua = navigator.userAgent;
            return /iPad|iPhone|iPod/.test(ua) && !window['MSStream']
        }

        function isArticle() {
            return window['TCTServer'] && !!window['TCTServer']['article'];
        }

        function shouldShowBanner() {
            return isArticle() && (isAndroid() || isIOS());
        }

        function shouldRunTest() {
            return false;
        }


        function scheduleBanner() {
            var duid = TCT.TrackingUtils.getSnowplowDuid();
            if (!!duid) {
                showBanner();
            } else {
                setTimeout(scheduleBanner, 25);
            }
        }

        function showBanner() {
            var url = window.location.href;
            var customCSS = '#branch-banner .content .left .details .title { font-size: ' + (screen.width > 380 ? '26px' : '22px') + '; }' +
                '#branch-banner .content .left .details .description { font-size: 12px; }' +
                '#branch-banner .content .left .details .description { max-height: 70px;} ';

            customCSS += "#branch-banner .vertically-align-middle{top:0;}" +
                "#branch-banner .content {background:white}" +
                "#branch-banner .vertically-align-middle {-webkit-transform: translateY(0);transform: translateY(0);}" +
                "#branch-banner .content .left {display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-pack: center;-ms-flex-pack: center;justify-content: center;position: relative;height: auto;}" +
                "#branch-banner .content .left.large-mode {padding:16px 0 0;margin:0;}" +
                "#branch-banner .content #branch-banner-close{background-color: white;font-size: 32px;padding: 0 22px 0 12px;top:8px;line-height: 1.2em;width:auto}" +
                "#branch-banner .content .left .details .description{font-size:13px}" +
                "@media(max-width:370px) {#branch-banner .content .left .details .description{font-size:12px}}" +
                "#branch-banner .content .left .icon {display: none;}" +
                "#branch-banner .content .left .details {-webkit-box-flex: 1;-ms-flex: 1 0 auto;flex: 1 0 auto;max-width: 410px;}" +
                "#branch-banner .content .left .details.large-mode {max-width: 200px;margin: 30px auto;}" +
                "#branch-banner .content .left .details .title{overflow:hidden;-webkit-transition:all 0.375s ease-out;transition:all 0.375s ease-out;display: block;padding-right: 6px;}" +
                "#branch-banner .content .left .details .description {-ms-flex-item-align: center;align-self: center;line-height: 18px;margin: 5px 0 10px;}" +
                "@media(max-width:415px) {#branch-banner .content .left .details #tct-banner-description {-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}" +
                "#branch-banner .content .left  .details > .title {font-size: 19px !important;}" +
                "#branch-banner .content .left .details .reviews {display: block;overflow:hidden;-webkit-transition:all 0.375s ease-out;transition:all 0.375s ease-out;}" +
                "#branch-banner .content .left .details .reviews .star span {color:#ffbe2f;}" +
                "#branch-banner .content .left .details .reviews {font-size:15px; line-height:22px}" +
                "#branch-banner .content .left .details #tct-banner-first-column {-webkit-box-flex: 1;-ms-flex: 1 0 auto;flex: 1 0 auto;padding-right: 37px;}" +
                "#branch-banner .content .right {margin: 0;padding: 0;height: auto;}" +
                "#branch-banner .content .right #branch-sms-form-container #branch-mobile-action {margin: 0;padding: 0;background-color: #6071ff;border-bottom-color: #6071ff;font-size: 16px;}" +
                ".branch-banner-is-active .share-icons.fixed {top:135px}" +
                ".branch-banner-is-active .share-icons.fixed.smaller  {top:135px}" +
                "@media(max-width:415px) {#branch-banner .content .right.collapsed {max-width:100px!important}}" +
                "@media(max-width:375px) {#branch-banner .content .left .details #tct-banner-first-column {padding-right:0;}}" +
                "#branch-banner .content .reviews .stars .star span.full>svg {fill: #ffbe2f;}" +
                "#branch-banner .content .reviews .stars .star span.half>svg {fill: #ffbe2f;}";

            var title = 'Culture Trip App';
            if (isAndroid()) {
                title = "Culture Trip for Android"
            } else if (isIOS()) {
                title = "Culture Trip for iOS"
            }

            var buttonText = "Install";
            if (isIOS()) {
                buttonText = "GET";
            }

            var whenInstalledText = "Open";
            var description = 'Find exciting things to see & do wherever you are!';
            var icon = 'https://cdn.theculturetrip.com/logo/ct-logo-75x75.png';


            window['branch'].addListener('didShowBanner', onDidShowBanner);

          if (!window.TCT.download_popup_deep_link && window.TCTTargeting) {
            var id = parseInt(window.TCTTargeting.articleId);
            if (id)
            { window.TCT.download_popup_deep_link = 'culturetrip://interrupt/showArticle?article=' + id + '&SOURCE=branch'; }
          }
          if (!window.TCT.download_popup_deep_link) {
            trackCTANoInteraction( TRACKING_PREFIX + 'issue', 'no deep link' );
          }

          TCT.debug('SP DUID:', TCT.TrackingUtils.getSnowplowDuid());
            TCT.debug('Branch data: ', {
                'interrupt branch param': window.TCT.download_popup_deep_link,
                'domain user id': TCT.TrackingUtils.getSnowplowDuid(),
                '$desktop_url': url,
                '$ios_url': 'https://itunes.apple.com/us/app/id1146832951',
                '$ipad_url': 'https://itunes.apple.com/us/app/id1146832951',
                '$og_title': 'Check out this article from \'Culture Trip\'',
                '$og_description': "'" + window.TCT.download_popup_post_title + "'",
                '$android_url': 'market://details?id=culturetrip.com'
            });
            window['branch']['banner']({
                icon: icon,
                title: title,
                description: description,
                openAppButtonText: whenInstalledText,
                downloadAppButtonText: buttonText,
                showiPad: true,
                showiOS: true,
                showAndroid: true,
                showDesktop: false,
                iframe: false,
                mobileSticky: true,
                position: 'top',
                rating: 4.7,
                customCSS: customCSS,
                forgetHide: 1
            }, {
                feature: testData && testData.variant ? testData.variant : '',
                channel: 'web',
                data: {
                    'interrupt branch param': window.TCT.download_popup_deep_link,
                    'domain user id': TCT.TrackingUtils.getSnowplowDuid(),
                    '$desktop_url': url,
                    '$ios_url': 'https://itunes.apple.com/us/app/id1146832951',
                    '$ipad_url': 'https://itunes.apple.com/us/app/id1146832951',
                    '$og_title': 'Check out this article from \'Culture Trip\'',
                    '$og_description': "'" + window.TCT.download_popup_post_title + "'",
                    '$android_url': 'market://details?id=culturetrip.com'
                }

            });

            function reportBannerView(testData) {
                trackCTANoInteraction(TRACKING_PREFIX + 'view' ,'interrupt branch param ' + window.TCT.download_popup_deep_link);

                if (testData && testData.variant) {
                    TCT.Testing.reportVariantVisible(testData);
                }
            }

            function onDidShowBanner() {
                TCT.debug('Branch onWillShowBanner');

                var topBar = document.getElementById("nav-home");
                var banner = document.getElementById("branch-banner");

                if (banner) {
                    // check button text to see if we need to make it disappear (in case app is already installed)
                    var button = document.getElementById('branch-mobile-action');
                    //Checking if the app install and remove the banner if it's
                    if (button && button.innerHTML === whenInstalledText) {
                        // hide banner
                        document.body.style.marginTop = 0;
                        banner.style.display = 'none';

                        if (window['branch']['closeBanner']) {
                            window['branch']['closeBanner']();
                        }

                        trackCTANoInteraction(TRACKING_PREFIX + 'auto_hide');
                        return;
                    }


                    reportBannerView(testData);


                    banner.parentNode.removeChild(banner);

                    var content = banner.childNodes[0];
                    var right = content.childNodes[0];
                    var left = content.childNodes[1],
                        closeIcon = left.childNodes[0],
                        description = left.childNodes[2];

                    content.removeChild(right);

                    right.style.paddingTop = 0 + "px";
                    right.style.width = "100%";

                    right.childNodes[0].style.width = "100%";
                    right.childNodes[0].style.textAlign = "center";
                    right.childNodes[0].style.marginTop = "-10px";
                    right.childNodes[0].childNodes[0].style.width = "65%";
                    right.childNodes[0].childNodes[0].style.lineHeight = "37px";
                    right.childNodes[0].childNodes[0].style.height = "35px";
                    right.childNodes[0].childNodes[0].style.fontSize = "22px";
                    jQuery(topBar.parentNode).prepend(banner);
                    left.style.paddingTop = screen.height > screen.width ? "12%" : "6%";
                    banner.style.position = "fixed";
                    banner.style.zIndex = 100;

                    var height = Math.max(screen.height / 3, 200) + 'px';

                    (function ($) {
                        var collapsedHeight = 0,
                            removeCollapsed = false,
                            collapsedBanner = false,
                            collapsBannerMode = false;


                        var $banner = $(banner),
                            $details = $('.left .details', $banner),
                            $right = $(right),
                            $left = $(left),
                            title = $('.title', $details),
                            reviews = $('.reviews', $details),
                            description = $('.description', $details),
                            bannerContent = $("#branch-banner .content"),
                            scrollStart = false;

                        description.remove();

                        //Add description section and button section to be under one div
                        $details.append($('<div id="tct-banner-description"></div>').append(description).append($right));

                        var $buttonLink = $('#branch-mobile-action', $details);

                        $right.css('max-width', "195px");
                        closeIcon.remove();
                        // left.removeChild(closeIcon);
                        $(content).prepend(closeIcon);

                        $buttonLink.css("width", "100%");

                        $left.css("padding-top", "16px");

                        //Clone this for smaller banner
                        var cloneDetails = $right.clone().prop('id', 'button-banner-sticky').css({
                                "max-height": "0",
                                "overflow": 'hidden',
                                "transition": "all 0.375s ease-out",
                                "-webkit-transition": "all 0.375s ease-out"
                            }),
                            cloneTitle = $(".title", $details).clone().prop('id', 'title-banner-sticky'),
                            cloneReview = $(".reviews", $details).clone().prop('id', 'review-banner-sticky');

                        //Hide the it until we start scroll
                        $details.append($('<div id="tct-banner-first-column"></div>').append(cloneTitle).append(cloneReview).css({
                            "max-height": "0",
                            "overflow": 'hidden',
                            "transition": "all 0.375s ease-out",
                            "-webkit-transition": "all 0.375s ease-out"
                        }));
                        $details.append(cloneDetails);
                        $('#branch-sms-form-container', cloneDetails).css("margin", '0');
                        //Save true if the smaller banner is display instead the big one
                        scrollStart = false;
                        height = Math.max(screen.height / 3, 200) + 'px';
                        $("#branch-banner .content #branch-banner-close").css({"position": "absolute"});
                        $("#branch-banner .content .left").addClass("large-mode");
                        $("#branch-banner .content .left .details").addClass("large-mode");

                        $(content).css("height", height);

                        function scrollDownloadAppBanner() {
                            collapsedHeight = !!collapsedHeight ? parseInt(collapsedHeight) : 0;
                            //hide the bigger banner and show the smaller one
                            if (this.scrollY > collapsedHeight && !scrollStart || (collapsedBanner)) {
                                var height = "73px";
                                scrollStart = true;

                                $("#branch-banner .content #branch-banner-close").css({"position": "relative"});
                                $("#branch-banner .content .left").removeClass("large-mode");
                                $("#branch-banner .content .left .details").removeClass("large-mode");
                                $("#branch-banner .content .right").addClass("collapsed");

                                $('>.title', $details).css({"max-height": "0px", "max-width": "0"});
                                $('>.reviews', $details).css({"max-height": "0px", "max-width": "0"});
                                $('#tct-banner-description', $details).css({
                                    "max-height": "0px",
                                    "max-width": "0"
                                });
                                $('#tct-banner-first-column', $details).css({
                                    "max-height": "60px",
                                    "max-width": "200px"
                                });
                                cloneDetails.css({"max-height": "60px", "max-width": "200px"});
                                $details.css("display", "flex");
                                bannerContent.css("height", height);
                                $('body').css("margin-top", height);
                                $('.branch-banner-is-active .share-icons.fixed').addClass('collapsed');
                                $('.branch-banner-is-active .share-icons.fixed').addClass('collapsed');
                                if (removeCollapsed) {
                                    removeScrollEvent();
                                }
                                changeNavBarHeight(height);

                            }
                            //hide the smaller banner and show the bigger one
                            else if (this.scrollY <= collapsedHeight && scrollStart) {
                                scrollStart = false;
                                height = "120px";

                                height = Math.max(screen.height / 3, 200) + 'px';
                                $("#branch-banner .content #branch-banner-close").css({"position": "absolute"});
                                $("#branch-banner .content .left").addClass("large-mode");
                                $("#branch-banner .content .left .details").addClass("large-mode");
                                $("#branch-banner .content .right").removeClass("collapsed");

                                $('>.title', $details).css({
                                    "max-height": "70px",
                                    "max-width": "300px"
                                });
                                $('>.reviews', $details).css({
                                    "max-height": "70px",
                                    "max-width": "300px"
                                });
                                $('#tct-banner-description', $details).css({
                                    "max-height": "70px",
                                    "max-width": "600px"
                                });
                                $('#tct-banner-first-column', $details).css({
                                    "max-height": "0px",
                                    "max-width": "0"
                                });
                                cloneDetails.css({"max-height": "0px", "max-width": "0"});
                                $details.css("display", "block");
                                bannerContent.css("height", height);
                                $('body').css("margin-top", height);
                                $('.branch-banner-is-active .share-icons.fixed').removeClass('collapsed');
                                changeNavBarHeight(height);
                            }
                        }

                        function changeNavBarHeight(top) {
                            var stickyNav = $('.stickywrapper');
                            if (stickyNav.length > 0) {
                                stickyNav.css({"top": top});
                            }
                            if ($('#mobile-menu').length > 0) {
                                $('#mobile-menu').css({'top': parseInt(top) + 80});
                            }
                            if ($('.mobile-new-menu').length > 0) {
                                $('.mobile-new-menu').css({'top': parseInt(top) + 80});
                            }

                        }

                        function removeScrollEvent() {
                            $(window).off('scroll', scrollDownloadAppBanner);
                            $('.branch-banner-is-active .share-icons.fixed').removeClass('collapsed');
                            $('body').off('focus', '#auto-complete-location-inspiration, #auto-complete-location-inspiration-sticky', collapsBanner);
                            $('body').off('blur', '#auto-complete-location-inspiration, #auto-complete-location-inspiration-sticky', returnToPreviousMode);
                        }

                        function collapsBanner() {
                            collapsBannerMode = collapsedBanner;
                            collapsedBanner = true;
                            scrollDownloadAppBanner();
                        }

                        function returnToPreviousMode() {
                            collapsedBanner = collapsBannerMode;
                        }

                        //this listener to change the top of the auto complete search result (because it fixed position)
                        $('body').on('focus', '#auto-complete-location-inspiration, #auto-complete-location-inspiration-sticky', collapsBanner);
                        $('body').on('blur', '#auto-complete-location-inspiration, #auto-complete-location-inspiration-sticky', returnToPreviousMode);


                        changeNavBarHeight(height);
                        //Add event that check every time if need to display the smaller banner If we in top 0 we display the bigger banner
                        $(window).on('scroll', scrollDownloadAppBanner);
                        $('#branch-banner-close').one("click", function () {
                            //This remove the bind event that change the banner from small to big.
                            removeScrollEvent();
                        });
                        $('#branch-mobile-action').one("click", function () {
                            //This remove the bind event that change the banner from small to big.
                            removeScrollEvent();
                        });
                        //Fixed the problem when the banner collapsed
                        $('#button-banner-sticky').on("click", function () {
                            $('#branch-mobile-action').get(0).click();
                        });


                        //default value for all test except controller variant
                        var desc = $('.description', $banner),
                            buttonContainer = $('#branch-sms-form-container', $banner),
                            button = $('.button', $banner);

                        title = $('.title', $banner);
                        title.css('font-size', '16px');
                        title.css('font-weight', '400');
                        title.css('font-family', "ProximaNova-SemiBold");
                        desc.css('font-family', "ProximaNova-Regular");
                        desc.css('font-weight', 'normal');
                        button.css('font-size', '16px');
                        button.css('font-weight', '400');
                        button.css('font-family', "ProximaNova-Regular");
                        button.css('letter-spacing', "normal");
                        buttonContainer.css("padding", "0");
                        buttonContainer.css("margin", "0");
                        button.addClass('ios-branch-button');
                        $right.css('max-width', 'none');


                    })(window.jQuery);

                    var margin = height;

                    document.body.style.marginTop = height;
                    right.style.marginBottom = "0px";

                    if (isIOS()) {
                        (function ($) {
                            var $banner = $(banner),
                                right = $('.right', $banner),
                                title = $('.title', $banner),
                                desc = $('.description', $banner),
                                button = $('.button', $banner);

                            button.addClass('ios-branch-button');
                            right.css('max-width', 'none');
                        })(window.jQuery);
                    }

                    document.getElementById("branch-banner-close").addEventListener("click", function () {
                        trackCTA(TRACKING_PREFIX + "close");
                        jQuery('.stickywrapper').css({"top": 0});
                        jQuery('#mobile-menu').css({'top': 80});
                        jQuery('.mobile-new-menu').css({'top': 80});
                    });

                    document.getElementById("branch-mobile-action").addEventListener("click", function () {
                        trackClick();
                        (function ($) {
                            var branchBanner = $('#branch-banner');
                            $('.stickywrapper').css({"top": 0});
                            $('#mobile-menu').css({'top': 80});
                            $('.mobile-new-menu').css({'top': 80});
                            if (branchBanner.length > 0) {
                                branchBanner.remove();
                                var body = $('body');
                                body.css("margin-top", 0);
                                body.removeClass("branch-banner-is-active");
                            }

                        })(window.jQuery);
                    });
                }
            }
        }

        function trackClick() {
            trackConversion(TRACKING_PREFIX + 'clicked');
            trackCTA(TRACKING_PREFIX + 'clicked');
        }

    })(window.jQuery);

}
